"use client";
import { useRef, useState, useEffect } from "react";
import { GoDotFill } from "react-icons/go";
import ScrollAnimation from "react-animate-on-scroll";
import Marquee from "react-fast-marquee";
import Partners from "../../../components/Partners";

// import Chart from "../../public/assets/chart.svg";

const SectionTwo = () => {
  const scrollRef = useRef(null);
  const [thumbTop, setThumbTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(0);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollRatio =
        container.scrollTop / (container.scrollHeight - container.clientHeight);
      const newThumbHeight =
        container.clientHeight *
        (container.clientHeight / container.scrollHeight);
      setThumbHeight(newThumbHeight);
      setThumbTop(scrollRatio * (container.clientHeight - newThumbHeight));
    };

    handleScroll(); // Initialize thumb on mount
    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const details = [
    {
      id: 1,
      label: "Say Goodbye to Spreadsheets",
      desc: "Centralize budgets, invoices, and reports—no more juggling spreadsheets.",
    },
    {
      id: 2,
      label: "Your Finance Hub",
      desc: "One platform for cash flow, payments, and financial insights.",
    },
    {
      id: 3,
      label: "Live Financial Insights",
      desc: "Real‑time financial dashboard: from transactions to analytics.",
    },
    {
      id: 4,
      label: "Bulk Payouts",
      desc: "Disburse mass payments in one click—any bank account or mobile wallet, on time."
    },
    {
      id: 5,
      label: "Storefront",
      desc: "Launch your online shop in minutes—custom domains, catalog management, checkout.",
    },
  ];
  const patners = [
    {
      id: 1,
      img: "./assets/lagos.svg",
    },
    {
      id: 2,
      img: "./assets/wema.svg",
    },
    {
      id: 3,
      img: "./assets/prov.svg",
    },
    {
      id: 4,
      img: "./assets/vfd.svg",
    },
    {
      id: 5,
      img: "./assets/orange.svg",
    },
    {
      id: 6,
      img: "./assets/hngr.svg",
    },
    {
      id: 7,
      img: "./assets/aws.svg",
    },
    {
      id: 8,
      img: "./assets/safa.svg",
    },
    {
      id: 9,
      img: "./assets/hub.svg",
    },
    {
      id: 10,
      img: "./assets/wipo.svg",
    },
    {
      id: 11,
      img: "./assets/paystack.svg",
    },
    {
      id: 12,
      img: "./assets/openai.svg",
    },
    {
      id: 13,
      img: "./assets/nitda.svg",
    },
    {
      id: 14,
      img: "./assets/lse.svg",
    },
    {
      id: 15,
      img: "./assets/azure.svg",
    },
  ];

  return (
    <div className="relative -mt-[48px] md:-mt-36 lg:-mt-64 xl:-mt-64 z-10 w-full px-[4px] py-4  bg-white rounded-[20px] md:rounded-[36px] lg:rounded-[48px] shadow-lg">
     <Partners />

      <div className="flex flex-col overflow-hidden lg:flex-row items-center gap-4 md:gap-12 lg:gap-4 px-5 py-2 md:px-8 lg:px-16 xl:px-32 xl:py-16">
        <div className="w-full md:w-[50%]  overflow-hidden flex ">
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            className="animate__animated  animate__delay-1s animate__slower"
          >
            <img
              src="/assets/chart.svg"
              alt="chart-logo"
              fill
              className="object-contain w-full h-[300px] md:h-[400px] lg:h-[480px]"
            />
          </ScrollAnimation>
        </div>

        <div className="w-full md:w-[50%] flex flex-col p-4">
          <div className="flex items-center justify-center lg:justify-start ">
            <button className="flex items-center justify-center gap-1 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
              <GoDotFill className="w-3 h-3 md:w-3 md:h-3 lg:w-4 lg:h-4" />
              <p className="whitespace-now-rap">Key Features Overview</p>
            </button>
          </div>

          <p className="font-semibold text-center lg:text-start mt-2 md:mt-4 text-sm md:text-xl lg:text-2xl xl:text-3xl mb-4 ">
            All your business finance <br className="hidden lg:block" /> one dashboard
          </p>
          <ScrollAnimation animateIn="fadeIn">
            <div className="flex gap-1 max-h-[250px] md:max-h-[400px] lg:max-h-[400px] pt-2 ">
              {/* scroller */}
              <div className="relative w-2 md:w-2 lg:w-2 mr-2 my-4 bg-gray-300 rounded-xl overflow-hidden">
                <div
                  className="absolute w-full bg-[#32AE4C] rounded-xl transition-all duration-100"
                  style={{
                    height: `${thumbHeight}px`,
                    top: `${thumbTop}px`,
                  }}
                ></div>
              </div>

              {/* Scrollable content */}
              <div
                ref={scrollRef}
                className="flex flex-col gap-2 md:gap-4 lg:gap-2 py-4 flex-1 overflow-y-scroll pr-2"
                style={{
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE
                }}
              >
                <style jsx>{`
                  div::-webkit-scrollbar {
                    display: none;
                  }
                `}</style>

                {details.map((item, index) => (
                  <div
                    key={item.id}
                    className={`px-4 py-4 md:py-4 lg:py-4 rounded-xl flex flex-col gap-2 ${
                      index === 0 ? "bg-[#EBF7ED]" : "border border-gray-400"
                    }`}
                  >
                    <p className="text-xs md:text-sm lg:text-base font-bold font-inter text-[#4B7453]">
                      {item.label}
                    </p>
                    <p className="text-xs md:text-xs lg:text-sm xl:text-base text-[#4B7453] font-inter">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
